import { render, staticRenderFns } from "./new-product-actions.vue?vue&type=template&id=4feaf571&scoped=true"
import script from "./new-product-actions.vue?vue&type=script&lang=js"
export * from "./new-product-actions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4feaf571",
  null
  
)

export default component.exports